/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import Modal from '../modal';
import '../../areas/account/sagas/terms';
import { Content, Error } from './styles';
import { AppState } from 'src/reducers';
import { acceptTermsRequest } from 'src/areas/account/actions';
import { UpdatedTerms, User } from 'src/types';

export const TocModal: React.FC = () => {
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();
  const me: StateUser = useSelector(
    (state: AppState) => state.areas.account.me
  );

  if (!me) {
    return null;
  }
  const items = (me?.updatedTerms?.filter(e => e !== null) ||
    []) as UpdatedTerms[];

  const acceptButtonClickHandler = () =>
    dispatch(acceptTermsRequest(items.map(({ policyType }) => policyType)));

  return items.length > 0 ? (
    <Modal isOpen shouldShowCloseIcon={false}>
      <div>
        <Content>
          {items.map(item => (
            <div key={item.policyId}>
              <h2>{item.title}</h2>
              {item.text && (
                <div dangerouslySetInnerHTML={{ __html: item.text }} />
              )}
            </div>
          ))}
        </Content>
        {me?.acceptPolicyError && <Error>{t('errors', 'error.unknown')}</Error>}
        <PrimaryButton onClick={acceptButtonClickHandler}>
          {t('common', 'button.ok')}
        </PrimaryButton>
      </div>
    </Modal>
  ) : null;
};

type StateUser = User & {
  acceptPolicyError: boolean;
};
